export default "__VITE_ASSET__ed19e79a__"